<template>
	<div class="record">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>浏览记录</span>
			<div @click="isDelete = true" v-if="isDelete == false">管理</div>
			<div @click="isDelete = false" v-else>完成</div>
		</div>
		<!-- 记录列表 -->
		<div v-for="item in recordList">
			<van-divider content-position="left" :style="{ color: '#000', borderColor: '#cecece', fontSize: '1rem'}" v-if="item.time == newDate">今天</van-divider>
			<van-divider content-position="left" :style="{ color: '#000', borderColor: '#cecece', fontSize: '1rem'}" v-else>{{item.time}}</van-divider>
			<div class="list" v-for="items in item.msg">
				<van-checkbox v-if="isDelete == true" v-model="isChecked" checked-color="#f1452f" icon-size="1rem"></van-checkbox>
				<van-card :thumb="items.src">
					<div slot="title" class="van_title">
						<span>{{items.title}}</span>
						<span class="active">¥{{items.price}}</span>
					</div>
					<div slot="desc" class="van_desc">
						{{items.desc}}
					</div>
					<div slot="price" class="van_type">
						<span>{{items.type}}</span>
						<van-icon name="shopping-cart-o" size="14px" color="#fff" />
					</div>
				</van-card>
			</div>
		</div>
		<!-- 底部 -->
		<div class="settle" v-if="isDelete == true">
			<div class="all">
				<van-checkbox checked-color="#f1452f" icon-size="1rem"></van-checkbox>
				<span>全选</span>
			</div>
			<div class="settle_btn">
				<van-button size="mini" round>删除</van-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isChecked: false,
				isDelete: false,
				newDate: '',
				recordList: [{
					time: '2019-12-07',
					msg: [{
						src: require('../../assets/bantai(2).png'),
						title: '格诺瓦 维纳 B款总裁台',
						price: '10000',
						desc: '2.8米×3.8米×1.5米 胡桃木色',
						type: '兆生家具 租五年'
					}, {
						src: require('../../assets/bantai(2).png'),
						title: '格诺瓦 维纳 B款总裁台',
						price: '999',
						desc: '2.8米×3.8米×1.5米 胡桃木色',
						type: '兆生家具 租五年'
					}]
				}, {
					time: '2019-12-06',
					msg: [{
						src: require('../../assets/bantai(2).png'),
						title: '格诺瓦 维纳 B款总裁台',
						price: '10000',
						desc: '2.8米×3.8米×1.5米 胡桃木色',
						type: '兆生家具 租2年'
					}]
				}]
			}
		},
		created() {
			var d = new Date();
			// 获取年，getFullYear()返回4位的数字
			var year = d.getFullYear();
			// 获取月，月份比较特殊，0是1月，11是12月
			var month = d.getMonth() + 1;
			// 变成两位
			month = month < 10 ? '0' + month : month;
			// 获取日
			var day = d.getDate();
			day = day < 10 ? '0' + day : day;
			this.newDate = year + '-' + month + '-' + day;
		}
	}
</script>

<style scoped>
	@import "record.css";
</style>



// WEBPACK FOOTER //
// src/components/min/record.vue